export const quotesForLoading = [
  { content: 'I never dreamed about success. I worked for it.', author: 'Estée Lauder' },
  {
    content:
      'Do not bring people in your life who weigh you down. And trust your instincts ... good relationships feel good. They feel right. They don’t hurt.',
    author: 'Oprah Winfrey',
  },
  {
    content: 'Risk more than others think is safe. Dream more than others think is practical.',
    author: 'Howard Schultz',
  },
  { content: 'The only way to do great work is to love what you do.', author: 'Steve Jobs' },
  {
    content:
      'The biggest risk is not taking any risk. In a world that is changing quickly, the only strategy that is guaranteed to fail is not taking risks.',
    author: 'Mark Zuckerberg',
  },
  {
    content: 'There’s no shortage of remarkable ideas, what’s missing is the will to execute them.',
    author: 'Seth Godin',
  },
  {
    content:
      'Don’t be intimidated by what you don’t know. That can be your greatest strength and ensure that you do things differently from everyone else.',
    author: 'Sara Blakely',
  },
  {
    content: 'I always did something I was a little not ready to do. I think that’s how you grow.',
    author: 'Marissa Mayer',
  },
  {
    content:
      'We need to accept that we won’t always make the right decisions, that we’ll screw up royally sometimes – understanding that failure is not the opposite of success, it’s part of success.',
    author: 'Arianna Huffington',
  },
  {
    content:
      'If you push through that feeling of being scared, that feeling of taking a risk, really amazing things can happen.',
    author: 'Marissa Mayer',
  },
  { content: 'Your most unhappy customers are your greatest source of learning.', author: 'Bill Gates' },
  { content: 'It’s not about ideas. It’s about making ideas happen.', author: 'Scott Belsky' },
  { content: 'You don’t need to have a 100-person company to develop that idea.', author: 'Larry Page' },
  {
    content: 'If you’re passionate about something and you work hard, then I think you will be successful.',
    author: 'Pierre Omidyar',
  },
  { content: 'Success is not just about making money. It’s about making a difference.', author: 'Mark Zuckerberg' },
  {
    content: 'You have to see failure as the beginning and the middle, but never entertain it as an end.',
    author: 'Jessica Herrin',
  },
  { content: 'I find that the harder I work, the more luck I seem to have.', author: 'Thomas Jefferson' },
  { content: "It's hard to beat a person who never gives up.", author: 'Babe Ruth' },
  {
    content: 'I knew that if I failed I wouldn’t regret that, but I knew the one thing I might regret is not trying.',
    author: 'Jeff Bezos',
  },
  {
    content:
      'Entrepreneurship is living a few years of your life like most people won’t, so you can spend the rest of your life like most people can’t.',
    author: 'Anonymous',
  },
];
